
export const environment = {
    production: true,
    envName: 'demo',
    apiHost: 'https://watchdog.pov-wd.com/builder',
};
